export default "__VITE_ASSET__nukCzWbg__"